/**
 * @fileoverview 共通ボタンコンポーネント
 *
 * このファイルでは、アプリケーション全体で一貫したデザインとインタラクションを
 * 提供するボタンコンポーネントを定義しています。複数のバリエーションや状態を
 * サポートし、アクセシビリティ要件にも対応しています。
 */

/**
 * ボタンコンポーネント
 *
 * アプリケーション全体で使用される標準化されたボタンコンポーネントです。
 * テキスト、アイコン、ローディング状態、無効状態などの様々な表示形式に対応し、
 * イベントハンドラや追加のプロパティを受け取ることができます。
 *
 * @param {Object} props - コンポーネントのプロパティ
 * @param {string} props.text - ボタンに表示するテキスト
 * @param {React.ReactNode} [props.leftIcon] - ボタンテキストの左に表示するアイコン
 * @param {React.ReactNode} [props.rightIcon] - ボタンテキストの右に表示するアイコン
 * @param {boolean} [props.loading=false] - ローディング状態を示すフラグ
 * @param {boolean} [props.disabled=false] - ボタンを無効化するフラグ
 * @param {string} [props.type='button'] - ボタンのタイプ属性（'button', 'submit', 'reset'）
 * @param {string} [props.variant='filled'] - ボタンの見た目のバリエーション
 * @param {string} [props.className] - 追加のCSSクラス名
 * @param {() => void} [props.onClick] - クリックイベントハンドラ
 * @returns {JSX.Element} スタイル適用済みのボタン要素
 */
import { FC } from "react";
import { Button as MantineButton } from "@mantine/core";

type Props = {
  text: string;
  className?: string;
  type?: "button" | "submit" | "reset";
  disabled?: boolean;
  loading?: boolean;
  onClick?: () => void;
};

export const Button: FC<Props> = ({
  text,
  className,
  type,
  disabled,
  loading,
  onClick,
}) => {
  return (
    <MantineButton
      type={type}
      className={`min-w-16 rounded-full bg-blue-600 hover:bg-blue-700 disabled:bg-blue-600 disabled:opacity-70 ${className}`}
      onClick={onClick}
      disabled={disabled}
      loading={loading}
      loaderProps={{
        color: "white",
        type: "dots",
      }}
    >
      {/* <LoadingOverlay
        visible={true}
        zIndex={30000}
        loaderProps={{ size: "lg", color: "#3182ce", type: "dots" }}
      /> */}
      {text}
    </MantineButton>
  );
};
